export default {
    Title: 'Tham số báo cáo',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    CodeAll: '<<Tất cả>>',
    NameAll: 'Tất cả',
    Year: 'Năm',
    All: 'Tất cả',
    SummaryCode: '<<Tổng hợp>>',
    Summary: 'Tổng hợp',
    Option: 'Tùy chọn',
    Source: 'Nguồn',
    PrintAdjustMonth: 'In tháng chỉnh lý quyết toán',
    IncludeAdjustVoucher: 'Bao gồm chứng từ chỉnh lý quyết toán',
    CheckFormula: 'Kiểm tra công thức',
    DisplayOption: 'Tùy chọn hiển thị',
    Period: 'Kỳ báo cáo',
    SelectAll: '<<Chọn tất>>',
    Unit: 'Đơn vị tính',
    Brass: 'Đồng',
    ThousandBrass: 'Nghìn đồng',
    RepeatTitle: 'Lặp lại tiêu đề'
  };
  